import React from 'react'
import {CheckedCircleIcon, EliplseIcon, Container} from "./GreenCheckedmarkWithText.styles";

interface GreenCheckmarkWithTextProps {
    header: string,
    description: string,
    isChecked: boolean,
}

const GreenCheckmarkWithText = ({header, description, isChecked}: GreenCheckmarkWithTextProps) => {
    return (
        <Container>
            {isChecked ? <CheckedCircleIcon /> : <EliplseIcon />}
            <div>
                <div className={'header'}>{header}</div>
                <div className={isChecked ? 'completedDescription' : 'description'}>{description}</div>
            </div>
        </Container>
    )
}

export default GreenCheckmarkWithText
